module.exports = ".description {\n  width: 70%;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-rows: auto auto auto;\n      grid-template-rows: auto auto auto; }\n\n.btn {\n  margin-top: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/disclaimer/disclaimer.component.scss
// module id = ./src/app/content/disclaimer/disclaimer.component.scss
// module chunks = main